/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Planner_CommandInputs */

const en_control_planner_command = /** @type {(inputs: Control_Planner_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command is a fixed unlock. This planner does not track game progression.`)
};

const zh_control_planner_command = /** @type {(inputs: Control_Planner_CommandInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Command 为固定解锁。本工具不追踪游戏进度。`)
};

/**
* | output |
* | --- |
* | "Command is a fixed unlock. This planner does not track game progression." |
*
* @param {Control_Planner_CommandInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_planner_command = /** @type {((inputs?: Control_Planner_CommandInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Planner_CommandInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_planner_command(inputs)
	return zh_control_planner_command(inputs)
});
export { control_planner_command as "control.planner.command" }